import { Action, createReducer, on } from '@ngrx/store';
import { CompanyGroupState } from './company-group.state';
import {
  ClearStateAction,
  getCompanyGroupAction,
  getCompanyGroupBySubDomainSuccessAction,
  getCompanyGroupErrorAction,
  getCompanyGroupSuccessAction,
} from './company-group.actions';

const initialState = new CompanyGroupState();

const reducer = createReducer(
  initialState,
  on(getCompanyGroupAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    return newState;
  }),
  on(getCompanyGroupSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.CompanyGroup = payload.CompanyGroup;
    return newState;
  }),
  on(getCompanyGroupBySubDomainSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.CompanyGroup = payload.CompanyGroup;
    return newState;
  }),
  on(getCompanyGroupErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(ClearStateAction, (state, payload) => {
    const newState = { ...state };
    switch (payload.actionType) {
      case 'companyGroup':
        newState.CompanyGroup = null;
        break;
      default:
        break;
    }
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  })
);

export function CompanyGroupReducer(state: CompanyGroupState | null, action: Action) {
  return reducer(state, action);
}
